import React from "react";

export const Logo = () => {
  return (
    <div className=" text-white font-inter mb-10">
      <h1 className="text-5xl font-black border-8 py-2 px-5 rounded-xl tracking-widest"> RDT </h1>
      <span className="uppercase font-bold font-xs mt-1 tracking-[0.3rem]"> Operaciones </span>
    </div>
  )
}